import React from "react";
import { Drawer } from "../../components/Modals";
const ProjectsDetailPage = React.lazy(() => import('../Projects/ProjectsDetailPage'));

const ShowSingleProjectModal = ({ setShowModal,isVisible=false,project_id } ) => {
    // const simHeaderBg = `bg-white dark:bg-[#111928]`;
    
    return (
        <>
        <Drawer
          isOpen={isVisible}
          onClose={() => setShowModal(false)}
          position="right"
          size={72}         
        >
            <div className="relative h-[100vh] flex flex-col">
                 <ProjectsDetailPage project_id={project_id} isTaskDataAvailable={false} />
            </div>  
        </Drawer>
        </>
    )
    
}

export default ShowSingleProjectModal;

